import Modernizr from 'modernizr';
import 'jquery-migrate/dist/jquery-migrate.js';
import './modules/_skip-link-focus-fix.js';
import './modules/_foundation-scripts.js';
import 'jquery-match-height/dist/jquery.matchHeight-min.js';
import 'mobile-mega-menu/build/scripts/jquery-mobile-mega-menu-min.js';

/**
 * Notes:
 *
 * Although jQuery is imported above, it is not bundulded
 * with the transpiled assets. jQuery needs to be global
 * on the website.
 *
 * All imports belong at the top of the file.
 *
 * Webpack only outputs this one script file, if you need
 * another file then add it to the scripts-list.js file as
 * another line in the scripts_list object.
 *
 * The scripts_list const is imported into the webpack
 * config. I've done this so that you do not have to
 * wade through the consfig to find what is being
 * compiled out as its own file.
 *
 * Also if you create another js file keep your scripts
 * within an immediately invoked function expression.
 * This will prevent other plugins or your own chunks
 * of code from conflicting with eachother. More info
 * can be found here:
 *
 * @link: http://benalman.com/news/2010/11/immediately-invoked-function-expression/
 */

/*************** SVG image replacement ***************/
if(!Modernizr.svg) {
	$('img[src*="svg"]').attr('src', function() {
		return $(this).attr('src').replace('.svg', '.png');
	});
}

if(!Modernizr.svg) {
	$('.loader').attr('src', function() {
		return $(this).attr('src').replace('.svg', '.gif');
	});
}

/*************** Template part region toggle button ***************/
$('.regions').click(function(event){
	event.preventDefault();

	$('.placeHolderPosition').slideToggle();
});

/*************** Flex Video ***************/
$('iframe[src*="player.vimeo.com"],[src*="www.youtube.com"],object[id="flashObj"]').each(function() {
	if (!$(this).parent().hasClass('flex-video')) {
		$(this).wrap('<div class="flex-video widescreen"/>');
	}
});

/*************** Menu ***************/
(function($) {
	var tab_anchors = $('#mega_menu_tabs a.mega');

	$(tab_anchors).on('click', function(event) {
		event.preventDefault();

		var item = $(this).data();
		var mega_menu_tab_items = $('#mega_menu_tab_items');

		if ( !$(this).hasClass('active') ) {
			mega_menu_tab_items.find('.items').hide();
			$(tab_anchors).removeClass('active');
		}
		mega_menu_tab_items.find('.' + item.id).toggle();
		$(this).addClass('active');
	});
})(jQuery);


/*************** Mobile Menu ***************/
$('.mobile-mega-menu').mobileMegaMenu({
	changeToggleText: false,
	enableWidgetRegion: false,
	prependCloseButton: true,
	stayOnActive: true,
	toogleTextOnClose: 'Close Menu',
	menuToggle: 'toggle-menu'
});

/*************** Search ***************/
$('.search-icon').click(function(event) {
	event.preventDefault();
	$('.search-field-container').slideToggle();
});

/*************** Open External Link in new window: Amazon Smile ***************/
$(document).ready(function(){
	$('a.link-amazon-smile').click(function(){
		window.open(this.href);
		return false;
	});
});

$(document).ready(function(){
	$('a.link-brick-campaign').click(function(){
		window.open(this.href);
		return false;
	});
});

/*************** Height Match ***************/
$('.match').matchHeight();
$('.type-product').matchHeight();

/*************** Live Chat ***************/
var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date(); // eslint-disable-line no-unused-vars
(function(){
	var s1=document.createElement('script'),s0=document.getElementsByTagName('script')[0];
	s1.async=true;
	s1.src='https://embed.tawk.to/5939947eb3d02e11ecc68e84/default';
	s1.charset='UTF-8';
	s1.setAttribute('crossorigin','*');
	s0.parentNode.insertBefore(s1,s0);
})();



// WEBPACK FOOTER //
// ./theme_components/js/global-scripts.js